export const CREATE_PARK_IN = 'CREATE_PARK_IN';
export const EDIT_PARK_IN = 'EDIT_PARK_IN';
export const SHOW_PARK_IN = 'SHOW_PARK_IN';
export const PARK_IN_SUCCESS = 'PARK_IN_SUCCESS';
export const PARK_OUT_ERROR = 'PARK_OUT_ERROR';
export const REMOVE_PARK_IN = 'REMOVE_PARK_IN';
export const RESTORE_PARK_IN = 'RESTORE_PARK_IN';

